import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import { ErrorCard } from '@/components/ErrorBoundary/ErrorCard';
import { WorkspaceIcon } from '@/components/workspace/WorkspaceIcon';
import { usePageTitle } from '@/hooks/usePageTitle';

/**
 * Экран аварии страницы в виде пустого состояния макета-эталона (empty-state,
 * docs/design/frontend-v2): страница упала при рендере, каркас остался. «Повторить»
 * рисует страницу заново, «К обзору» уводит с неё.
 */
export function RouteErrorScreen({ onRetry }: { onRetry: () => void }) {
	const { t } = useTranslation('common');
	usePageTitle(t('errors.somethingWrong'));

	return (
		<ErrorCard description="errors.pageCrashed">
			<div className="ws-heading-actions">
				<button type="button" className="ws-btn" onClick={onRetry}>
					{t('workspaceState.retry')}
				</button>
				<Link className="ws-btn" to="/overview">
					<WorkspaceIcon name="list" />
					{t('actions.toOverview')}
				</Link>
			</div>
		</ErrorCard>
	);
}

/**
 * Авария вне каркаса -- errorElement корневого маршрута: гостевые страницы и сам каркас.
 * Состояние приложения после неё не гарантировано, поэтому «Повторить» перезагружает
 * страницу.
 */
export function RootRouteError() {
	return (
		<div className="flex h-screen items-center justify-center">
			<RouteErrorScreen onRetry={() => window.location.reload()} />
		</div>
	);
}
